import { useEffect } from 'react'
import { env } from '@/config/env'

export function useDocumentTitle(title: string) {
  useEffect(() => {
    const prev = document.title
    document.title = `${title} - ${env.VITE_APP_NAME}`
    return () => {
      document.title = prev
    }
  }, [title])
}
